<div (click)="clicked.emit($event)" class="ds-checkbox-holder">
  <input
    [tabindex]="tabIndex"
    class="checkbox-input"
    type="checkbox"
    [ngModel]="checked"
    (ngModelChange)="onModelChange($event)"
    [disabled]="disabled"
    (change)="onChange($event)"
  />
  <div
    class="ds-checkbox"
    tabindex="-1"
    [ngClass]="{
      'type-box': variant === 'box',
      'align-center': checkboxPosition === 'center',
      checked: checked,
      'has-error': hasError,
      disabled: disabled
    }"
  >
    <div class="checkbox-border">
      <app-ds-icon *ngIf="checked" name="check" color="var(--color-core-neutral-0)"></app-ds-icon>
    </div>

    <label>
      @if (label || additionalInfo) {
        <p class="ds-ui-2" *ngIf="label">
          {{ label }}
        </p>
        <p *ngIf="variant === 'box'" class="ds-ui-2 additional-info">
          {{ additionalInfo }}
        </p>
      } @else {
        <ng-content></ng-content>
      }
    </label>
  </div>
  <p *ngIf="hasError && errorMessage && !checked && !disabled" class="ds-ui-3 ds-checkbox-error">
    {{ errorMessage }}
  </p>
</div>
